export default "__VITE_ASSET__tdKeg9b2__"